var Bavaria = "بافاريا";
var Berlin = "برلين";
var Brandenburg = "براندنبورغ";
var Bremen = "بريمن";
var Hamburg = "هامبورغ";
var Hesse = "هيسن";
var Saarland = "سارلاند";
var Saxony = "ساكسونيا";
var Thuringia = "تورينغن";
var DEStates = {
	"Baden-Wuerttemberg": "بادن فورتمبيرغ",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "ميكلينبورغ فوربومرن",
	"Lower Saxony": "ساكسونيا السفلى",
	"North Rhine-Westphalia": "شمال الراين فستفاليا",
	"Rhineland-Palatinate": "راينلاند بالاتينات",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "ساكسونيا أنهالت",
	"Schleswig-Holstein": "شليسفيغ هولشتاين",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
